import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'toNameImage',
    standalone: false
})
@Injectable({
	providedIn: 'root',
})
export class ToNameImage implements PipeTransform {

  constructor() {

  }

  transform(value: string): string {
    if (!value) return '';
    const values = value.split(" ");
    let text = '';
    values.forEach(t => {
      t = t.toLowerCase();
      text = text + t.charAt(0).toUpperCase() + t.slice(1);
    });

    return [...text].reduce((caps, char) => char.match(/[A-Z]/) ? caps + char : caps,'');
  }
}
